export default "__VITE_ASSET__HXqpzGCB__"